import React, { useState, useEffect, useCallback } from "react";
import { Layout, Menu, Row, Typography, Space } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import IconMap from "../../constants/icons";
import {
  onedataconnectlogogreen,
  dtlogo,
  onedataconnectfavicon,
} from "../../assets/images/images";
import "./sidebarcomponent.scss";
import AlertComponent from "../alerts/AlertComponent";
import { getData } from "@services/apiConfig";
import { fetchusercreationstatus } from "../../constants/endpoints";
import { showLoader } from "@store/actions/loaderAction";
import { useActivityLogger } from "../../hooks/useActivityLogger";
import { useNavigate } from "react-router-dom";
import { saveUserToCookies } from "../authentication/authUtils";

const { Sider } = Layout;
const { Text } = Typography;

const SidebarComponent = ({ collapsed }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const themeColor = useSelector((state) => state.basicConfigReducer?.theme);

  const sidebarMenuReducer = useSelector(
    (state) => state.basicConfigReducer?.sidebarMenu || []
  );
  const userDetailReducer = useSelector(
    (state) => state.basicConfigReducer.userdetails || null
  );

  const consoleData = useSelector(
    (state) => state.basicConfigReducer?.console || null
  );

  const [selectedKeys, setSelectedKeys] = useState([]);
  const [sidebarMenu, setSidebarMenu] = useState([]);
  const [themeType, setthemeType] = useState("light");

  const [stateOpenKeys, setStateOpenKeys] = useState([]);
  const [levelKeys, setlevelKeys] = useState([]);
  const [user, setUser] = useState({});
  const { logCustomActivity } = useActivityLogger();
  const navigate = useNavigate();

  const getKeyByPath = useCallback((path, menuItems) => {
    // Iterate over each menu item
    for (const menuItem of menuItems) {
      // Check if the current menu item's path matches the target path
      if (menuItem.path === path) {
        // Return the key of the matching menu item
        return menuItem.key;
      }
      // If the current menu item has children, recursively search within its children
      if (menuItem.children) {
        const key = getKeyByPath(path, menuItem.children);
        if (key) {
          return key;
        }
      }
    }
    // If no match is found, return null
    return null;
  }, []);

  // Function to find the keys of the submenu items that should be open
  const findParentKeys = useCallback((data, path, parentKeys = []) => {
    for (const item of data) {
      if (item.path === path) {
        return [...parentKeys, item.key];
      }
      if (item.children) {
        const keys = findParentKeys(item.children, path, [
          ...parentKeys,
          item.key,
        ]);
        if (keys.length) {
          return keys;
        }
      }
    }
    return [];
  }, []);

  function findKeyPath(items, targetKey) {
    let path = [];

    function search(items, targetKey, currentPath) {
      for (const item of items) {
        const newPath = [...currentPath, item.key];
        if (item.key === targetKey) {
          path = newPath;
          return true;
        }
        if (item.children) {
          if (search(item.children, targetKey, newPath)) {
            return true;
          }
        }
      }
      return false;
    }

    search(items, targetKey, []);
    return path;
  }

  useEffect(() => {
    // Extract the pathname from the location object
    const { pathname } = location;
    // Update the selected menu item based on the pathname
    // setSelectedKey(pathname);
    let key = getKeyByPath(pathname, sidebarMenuReducer);
    // console.log("key>>>>", key);

    const keyPath = findKeyPath(sidebarMenuReducer, key);
    // console.log("keyPath>>>>", keyPath);

    setStateOpenKeys(keyPath);
    setSelectedKeys([key]);
  }, [location, getKeyByPath, sidebarMenuReducer, findParentKeys]);

  useEffect(() => {
    if (themeColor === "dark") {
      setthemeType("light");
    } else {
      setthemeType("dark");
    }
  }, [themeColor]);

  useEffect(() => {
    if (sidebarMenuReducer && userDetailReducer && sidebarMenuReducer.length) {
      let sideBarMenu = sidebarMenuReducer;
      if (
        userDetailReducer.categoryoforganisation &&
        userDetailReducer.categoryoforganisation === "individual"
      ) {
        sideBarMenu = sidebarMenuReducer.map((item) => {
          if (item.key === "masterdatamanagement") {
            return {
              ...item,
              children: item.children.filter(
                (child) => child.key !== "masterdataupload"
              ),
            };
          }
          return item;
        });
      }

      computeSidebar(sideBarMenu);
    }
  }, [sidebarMenuReducer, userDetailReducer]);

  const computeSidebar = async (sidebarArr) => {
    let sdm = [];
    function r_sdm(arr) {
      return arr
        .filter((o) => !o.disable)
        .map((o) => {
          const IconComponent = IconMap[o.icon]; // Get the corresponding icon component

          if (o.children && o.children.length) {
            let sdm_children = r_sdm(o.children);
            return {
              ...o,
              label: o.path ? <Link to={o.path}>{o.label}</Link> : o.label,
              ...(IconComponent ? { icon: <IconComponent /> } : {}),
              children: sdm_children,
            };
          } else {
            const { externallink, ...rest } = o;
            return {
              ...rest,
              label: rest.path ? (
                <Link
                  to={rest.path}
                  target={externallink && externallink === true ? "_blank" : ""}
                  onClick={() => {
                    if (["naca", "clm", "climate", "fmoh"].includes(o.key)) {
                      sessionStorage.setItem("dashboardModuleName", o.key);
                      sessionStorage.setItem(
                        "userorglevel",
                        consoleData.userorglevel || null
                      );
                      sessionStorage.setItem(
                        "userorgunit",
                        consoleData.userorgunit || null
                      );
                      sessionStorage.setItem(
                        "programid",
                        consoleData.programType || null
                      );
                      sessionStorage.setItem(
                        "dashboardaccess",
                        consoleData.dashboardaccess || null
                      );
                      sessionStorage.setItem(
                        "groups",
                        consoleData.groups || null
                      );
                      sessionStorage.setItem(
                        "isSession",
                        consoleData.isSession || null
                      );
                      sessionStorage.setItem("uid", consoleData.uid || "");
                      sessionStorage.setItem(
                        "nacaAllowedModules",
                        consoleData.nacaAllowedModules || []
                      );
                      if (typeof consoleData?.nacaAllowedModules === "string") {
                        consoleData.nacaAllowedModules = JSON.parse(
                          consoleData.nacaAllowedModules
                        );
                      }
                      const moduleData = consoleData?.nacaAllowedModules.find(
                        (mod) => mod.dashboardModuleName === o?.key
                      );
                      console.log("moduledata", moduleData?.orgunit);
                      const ulvl = moduleData?.orglevel || 1;
                      const cid = JSON.stringify(moduleData?.orgunit || []);
                      sessionStorage.setItem("ulvl", ulvl);
                      sessionStorage.setItem("cid", cid);

                      sessionStorage.setItem(
                        "dashboardSchema",
                        consoleData.dashboardSchema || "new"
                      );
                    } else {
                      sessionStorage.setItem("dashboardModuleName", null);
                    }
                    saveUserToCookies(userDetailReducer);
                  }}
                >
                  {rest.label}
                </Link>
              ) : (
                rest.label
              ),
              ...(IconComponent ? { icon: <IconComponent /> } : {}),
            };
          }
        });
    }
    // console.log("sidebarArr >> ", sidebarArr);
    sdm = r_sdm(sidebarArr);
    // console.log("sidebarMenu>>>", sdm);
    setSidebarMenu(sdm);

    const getLevelKeys = (items1) => {
      const key = {};
      const func = (items2, level = 1) => {
        items2.forEach((item) => {
          if (item.key) {
            key[item.key] = level;
          }
          if (item.children) {
            func(item.children, level + 1);
          }
        });
      };
      func(items1);
      return key;
    };

    const levelKeys1 = await getLevelKeys(sdm);
    // console.log("levelKeys1>>", levelKeys1);
    setlevelKeys(levelKeys1);
  };

  const fetchUserStatus = async () => {
    try {
      let userstatusapi = {
        url: `${fetchusercreationstatus}?user_id=${userDetailReducer._id}`,
        baseName: "core",
      };
      dispatch(showLoader(true));
      let response = await getData(userstatusapi);
      dispatch(showLoader(false));

      if (response.status === 200) {
        return response.userstatus;
      }
    } catch (err) {
      dispatch(showLoader(false));
    }
  };

  const handleMenuClick = async ({ key, domEvent }) => {
    // Get current time and createdAt time
    if (key === "naca") {
      const currentTime = new Date().getTime();
      const createdAtTime = new Date(userDetailReducer.createdAt).getTime();
      const thirtyMinutes = 5 * 60 * 1000; // 30 minutes in milliseconds (Fixed issue)
      // Calculate activation time
      const activationTime = createdAtTime + thirtyMinutes;
      if (key === "naca" && currentTime < activationTime) {
        domEvent.preventDefault(); // Prevent default behavior
        AlertComponent({
          type: "warning",
          title: "Warning",
          text: `Access Pending! Your account will be fully activated in 30 minutes. Please try again later.`,
          icon: "warning",
        });
        return; // Prevent further execution
      }
    }
  };

  // const handleMenuClick = (e) => {
  //   const clickedKey = e.key; // this corresponds to the route or module key
  //   const clickedItem = sidebarMenu.find((item) => item.key === clickedKey);

  //   logCustomActivity({
  //     type: "module-click",
  //     module: clickedItem?.label || clickedKey, // label if available
  //     path: clickedItem?.key, // the route
  //   });

  //   // existing navigation logic, e.g.
  //   navigate(clickedItem.key); // or however you route to the clicked module
  // };

  const onOpenChange = (openKeys) => {
    // const currentOpenKey = openKeys.find(
    //   (key) => stateOpenKeys.indexOf(key) === -1
    // );
    // // open
    // if (currentOpenKey !== undefined) {
    //   const repeatIndex = openKeys
    //     .filter((key) => key !== currentOpenKey)
    //     .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
    //   // Update stateOpenKeys with the changes
    //   const newOpenKeys = openKeys
    //     .filter((_, index) => index !== repeatIndex)
    //     .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]);
    //   setStateOpenKeys(newOpenKeys);
    //   dispatch(setSidebarOpenMenu(newOpenKeys));
    // } else {
    //   // close
    //   setStateOpenKeys(openKeys);
    //   dispatch(setSidebarOpenMenu(openKeys));
    // }
  };

  return (
    <Sider
      theme={themeType}
      id="sidebar-component"
      width={250}
      className="site-layout-background"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        zIndex: 2,
      }}
    >
      <div
        className="sidear-header"
        style={{ position: "sticky", top: 0, zIndex: 1 }}
      >
        {collapsed ? (
          <img
            id="sidebar-logo-img-favicon"
            src={onedataconnectfavicon}
            alt="logo"
          />
        ) : (
          <img id="sidebar-logo-img" src={onedataconnectlogogreen} alt="logo" />
        )}
      </div>
      <div
        className="sidebar-content"
        style={{ flex: 1, overflowY: "auto", height: "calc(90vh - 120px)" }}
      >
        <Menu
          key={selectedKeys}
          theme={themeType}
          mode="inline"
          defaultSelectedKeys={selectedKeys}
          defaultOpenKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
          onClick={(e) => handleMenuClick(e)}
          style={{ height: "80%", borderRight: 0 }}
          items={sidebarMenu}
        />
      </div>
      {!collapsed && (
        <div
          className="sidebar-footer"
          style={{ position: "fixed", bottom: 0, zIndex: 1 }}
        >
          <Row>
            <Space size={30}>
              <Text className="developer-name-text">Powered By</Text>
            </Space>
          </Row>
          <Row>
            <img id="sidebar-logo-img" src={dtlogo} alt="logo" />
          </Row>
        </div>
      )}
    </Sider>
  );
};

export default SidebarComponent;
